<div class="card detail">
  <div class="card-body">
    <div class="title text-left">
      <h3 class="card-title">{{ "Layer" | translate }}</h3>
    </div>
    <ul class="list-group overflow-visible">
      <ng-container *ngIf="currLocation?.map_layer_ortho && !splitScreenOn">
        <li class="list-group-item">
          <div class="toggle-container">
            <app-toggle-switch
              [selected]="isOrtho"
              (change)="isOrtho = !isOrtho"
            ></app-toggle-switch>
            <i class="icon-ortho"></i>
            <p>{{ "Orthophoto" | translate }}</p>

            <div class="nested-toggle" *ngIf="isOrtho">
              <div class="card card-body">
                <ul class="list-group">
                  <ng-container>
                    <p class="text-left mb-2 font-weight-bold">
                      {{ "Ortho Layer List" | translate }}
                    </p>
                    <li class="list-group-item">
                      <div class="toggle-container">
                        <app-toggle-switch
                          [selected]="
                            currLocation?.map_layer_ortho_all.length ===
                            orthoManyLayerFilter.length
                          "
                          (change)="toggleAllOrthoLayer($event)"
                        ></app-toggle-switch>
                        <p>{{ "All" | translate }}</p>
                      </div>
                    </li>
                    <li
                      class="list-group-item"
                      *ngFor="
                        let mlo of currLocation?.map_layer_ortho_all;
                        let idx = index
                      "
                    >
                      <div class="toggle-container">
                        <app-toggle-switch
                          [selected]="orthoManyLayerFilter.includes(mlo.id)"
                          (change)="toggleOrthoManyLayer(mlo)"
                        ></app-toggle-switch>
                        <p class="text-ellipsis">
                          {{ mlo.layer_name || mlo.id }}
                        </p>
                        <div class="action-btn ml-1" *ngIf="!isSplitscreenOn">
                          <a
                            class="
                              btn btn-sm btn-circle btn-outline-primary btn-tool
                            "
                            (click)="onPinMapLayer('ortho_' + mlo.id)"
                            [class.active]="
                              (currLocation.pinned_map_layer_type?.includes(
                                'ortho'
                              ) &&
                                idx ===
                                  currLocation.map_layer_ortho_all.length -
                                    1) ||
                              currLocation.pinned_map_layer_type?.includes(
                                'ortho_' + mlo.id
                              )
                            "
                            data-cy="pin-layer-ortho-button"
                          >
                            <i [class]="'icon-clusters'"></i>
                            <span
                              class="tooltip-text"
                              style="margin-top: -3em; margin-left: -3.5em"
                              >{{
                                (currLocation.pinned_map_layer_type?.includes(
                                  "ortho"
                                ) &&
                                  idx ===
                                    currLocation.map_layer_ortho_all.length -
                                      1) ||
                                currLocation.pinned_map_layer_type?.includes(
                                  "ortho_" + mlo.id
                                )
                                  ? "Unpin layer"
                                  : ("Pin layer" | translate)
                              }}</span
                            >
                          </a>
                        </div>
                      </div>
                    </li>
                  </ng-container>
                </ul>
              </div>
            </div>
          </div>
        </li>
      </ng-container>
      <ng-container *ngIf="currLocation?.map_layer_dsm && !splitScreenOn">
        <li class="list-group-item">
          <div class="toggle-container">
            <app-toggle-switch
              [selected]="isDSM"
              (change)="toggleSwitch('map_layer', 'dsm')"
            ></app-toggle-switch>
            <i class="icon-ortho"></i>
            <p>{{ "DSM" | translate }}</p>
            <div class="action-btn ml-1" *ngIf="!isSplitscreenOn">
              <a
                class="btn btn-sm btn-circle btn-outline-primary btn-tool"
                (click)="onPinMapLayer('dsm_' + currLocation?.map_layer_dsm.id)"
                [class.active]="
                  currLocation.pinned_map_layer_type?.includes('dsm') ||
                  currLocation.pinned_map_layer_type?.includes(
                    'dsm_' + currLocation?.map_layer_dsm.id
                  )
                "
                data-cy="pin-layer-dsm-button"
              >
                <i [class]="'icon-clusters'"></i>
                <span
                  class="tooltip-text"
                  style="margin-top: -3em; margin-left: -3.5em"
                  >{{
                    currLocation.pinned_map_layer_type?.includes("dsm") ||
                    currLocation.pinned_map_layer_type?.includes(
                      "dsm_" + currLocation?.map_layer_dsm.id
                    )
                      ? "Unpin layer"
                      : ("Pin layer" | translate)
                  }}</span
                >
              </a>
            </div>
            -->
          </div>
        </li>
      </ng-container>
      <ng-container *ngIf="currLocation?.map_layer_thermal && !splitScreenOn">
        <li class="list-group-item">
          <div class="toggle-container">
            <app-toggle-switch
              [selected]="isThermal"
              (change)="toggleSwitch('map_layer', 'thermal')"
            ></app-toggle-switch>
            <i class="icon-thermal"></i>
            <p>{{ "Thermal Orthophoto" | translate }}</p>
            <div class="action-btn ml-1" *ngIf="!isSplitscreenOn">
              <a
                class="btn btn-sm btn-circle btn-outline-primary btn-tool"
                (click)="
                  onPinMapLayer('thermal_' + currLocation?.map_layer_thermal.id)
                "
                [class.active]="
                  currLocation.pinned_map_layer_type?.includes('thermal') ||
                  currLocation.pinned_map_layer_type?.includes(
                    'thermal_' + currLocation?.map_layer_thermal.id
                  )
                "
                data-cy="pin-layer-thermal-button"
              >
                <i [class]="'icon-clusters'"></i>
                <span
                  class="tooltip-text"
                  style="margin-top: -3em; margin-left: -3.5em"
                  >{{
                    currLocation.pinned_map_layer_type?.includes("thermal") ||
                    currLocation.pinned_map_layer_type?.includes(
                      "thermal_" + currLocation?.map_layer_thermal.id
                    )
                      ? "Unpin layer"
                      : ("Pin layer" | translate)
                  }}</span
                >
              </a>
            </div>
          </div>
        </li>
      </ng-container>
      <ng-container *ngIf="currLocation?.map_layer_3d_mesh && !splitScreenOn">
        <li class="list-group-item">
          <div class="toggle-container">
            <app-toggle-switch
              [selected]="isThreeDMesh"
              (change)="toggleSwitch('map_layer', '3d-mesh')"
            ></app-toggle-switch>
            <i class="icon-d-mesh"></i>
            <p>{{ "3D Mesh" | translate }}</p>
            <div class="action-btn ml-1" *ngIf="!isSplitscreenOn">
              <a
                class="btn btn-sm btn-circle btn-outline-primary btn-tool"
                (click)="
                  onPinMapLayer('3d-mesh_' + currLocation?.map_layer_3d_mesh.id)
                "
                [class.active]="
                  currLocation.pinned_map_layer_type?.includes('3d-mesh') ||
                  currLocation.pinned_map_layer_type?.includes(
                    '3d-mesh_' + currLocation?.map_layer_3d_mesh.id
                  )
                "
                data-cy="pin-layer-3d-mesh-button"
              >
                <i [class]="'icon-clusters'"></i>
                <span
                  class="tooltip-text"
                  style="margin-top: -3em; margin-left: -3.5em"
                  >{{
                    currLocation.pinned_map_layer_type?.includes("3d-mesh") ||
                    currLocation.pinned_map_layer_type?.includes(
                      "3d-mesh_" + currLocation?.map_layer_3d_mesh.id
                    )
                      ? "Unpin layer"
                      : ("Pin layer" | translate)
                  }}</span
                >
              </a>
            </div>
            -->
          </div>
        </li>
      </ng-container>
      <ng-container
        *ngIf="
          currLocation?.map_layer_embed &&
          currLocation?.map_layer_embed.length > 0 &&
          !splitScreenOn
        "
      >
        <li
          class="list-group-item annotation-container"
          [class.is-active]="isEmbed"
        >
          <div class="toggle-container">
            <app-toggle-switch
              [selected]="isEmbed"
              (change)="toggleSwitch('map_layer', 'embed')"
            ></app-toggle-switch>
            <i class="icon-annotation-box-2"></i>
            <p>{{ "Embed" | translate }}</p>
          </div>
          <div class="nested-toggle" *ngIf="isEmbed">
            <div class="card card-body">
              <ul class="list-group">
                <ng-container *ngIf="embedLayers?.length > 0">
                  <p class="text-left mb-2 font-weight-bold">
                    {{ "Embed Layer List" | translate }}
                  </p>
                  <li
                    class="list-group-item"
                    *ngFor="let item of embedLayers; trackById"
                  >
                    <div class="toggle-container">
                      <app-toggle-switch
                        [selected]="embedLayerFilter.includes(item.id)"
                        (change)="toggleEmbedLayer(item.id)"
                      ></app-toggle-switch>
                      <p>{{ item.id }}</p>
                    </div>
                  </li>
                </ng-container>
              </ul>
            </div>
          </div>
        </li>
      </ng-container>
      <ng-container
        *ngIf="
          currLocation?.map_layer_geojson &&
          currLocation?.map_layer_geojson.length > 0 &&
          !splitScreenOn
        "
      >
        <li
          class="list-group-item annotation-container"
          [class.is-active]="isGeojson"
        >
          <div class="toggle-container">
            <app-toggle-switch
              [selected]="isGeojson"
              (change)="toggleSwitch('map_layer', 'geojson')"
            ></app-toggle-switch>
            <i class="icon-annotation-box-2"></i>
            <p>{{ "Geojson" | translate }}</p>
          </div>
          <div class="nested-toggle" *ngIf="isGeojson">
            <div class="card card-body" style="height: 23em; width: 20em">
              <ul class="list-group hide-scrollbar">
                <ng-container *ngIf="geojsonLayers?.length > 0">
                  <!-- ------------------------------- Header -------------------------------- -->
                  <div style="display: flex; justify-content: space-between">
                    <p class="text-left mb-2 font-weight-bold" style="flex: 2">
                      {{ "Geojson Layer List" | translate }}
                    </p>
                    <div
                      class="action-btn"
                      style="flex: 1; justify-content: end"
                    >
                      <a
                        class="
                          btn btn-sm btn-circle btn-outline-primary btn-tool
                        "
                        (click)="isShowFormGroup = !isShowFormGroup"
                        *ngIf="isEditGeojson"
                      >
                        <i [class]="'icon-create'"></i>
                        <span
                          class="tooltip-text"
                          style="margin-top: -3em; margin-left: -4.5em"
                          >Create Group
                        </span>
                      </a>
                      <app-toggle-switch
                        *ngIf="
                          currentUser.roles[0] === 'SuperAdmin' ||
                          currentUser.roles[0] === 'Admin'
                        "
                        [selected]="isEditGeojson"
                        (change)="toggleEditGeojson()"
                      ></app-toggle-switch>
                    </div>
                  </div>
                  <!-- -------------------------------- body --------------------------------- -->
                  <li class="list-group-item">
                    <div class="tree-container">
                      <ul id="myUL">
                        <li *ngFor="let group of geoJsonGroup">
                          <p class="caret" [id]="'btn-group-' + group._id">
                            <span style="padding-right: 10px"
                              >{{ group.name }}
                            </span>
                            <i
                              *ngIf="isEditGeojson"
                              [class]="'icon-edit'"
                              (click)="showElement(group._id, 'group')"
                            ></i>
                            <i
                              *ngIf="isEditGeojson"
                              [class]="'icon-delete'"
                              style="color: red"
                              (click)="
                                onSubmitForm(
                                  'formGeojsonGroup',
                                  'delete',
                                  group._id
                                )
                              "
                            ></i>
                          </p>
                          <form
                            [id]="'form-group-' + group._id"
                            style="display: none"
                            [formGroup]="formGeojsonGroup"
                            (ngSubmit)="
                              onSubmitForm(
                                'formGeojsonGroup',
                                'edit',
                                group._id
                              )
                            "
                          >
                            <div class="form-row">
                              <div class="col-9">
                                <div class="form-group p-0">
                                  <input
                                    formControlName="name"
                                    type="text"
                                    class="form-control"
                                    placeholder="{{ group.name | translate }}"
                                  />
                                </div>
                              </div>
                              <div class="col-3 d-flex form-group">
                                <div class="action-btn">
                                  <button
                                    class="
                                      btn
                                      btn-sm
                                      btn-circle
                                      btn-outline-primary
                                      btn-tool
                                    "
                                    type="submit"
                                  >
                                    <i [class]="'icon-pencil'"></i>
                                    <span
                                      class="tooltip-text"
                                      style="
                                        margin-top: -3em;
                                        margin-left: -4.5em;
                                      "
                                      >Edit Group
                                    </span>
                                  </button>
                                </div>
                                <div class="action-btn">
                                  <button
                                    class="
                                      btn btn-sm btn-circle btn-outline-danger
                                    "
                                    type="button"
                                    (click)="hideElement(group._id, 'group')"
                                  >
                                    <i class="icon-delete"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </form>
                          <ul class="nested">
                            <li *ngFor="let subgroup of group.subgroup">
                              <p
                                class="caret"
                                [id]="'btn-subgroup-' + subgroup.id + '-edit'"
                              >
                                {{ subgroup.name }}
                                <i
                                  *ngIf="isEditGeojson"
                                  [class]="'icon-edit'"
                                  (click)="
                                    showElement(
                                      subgroup.id + '-edit',
                                      'subgroup'
                                    )
                                  "
                                ></i>
                                <i
                                  *ngIf="isEditGeojson"
                                  [class]="'icon-delete'"
                                  style="color: red"
                                  (click)="
                                    onSubmitForm(
                                      'formGeojsonSubgroup',
                                      'delete',
                                      group._id,
                                      subgroup.id
                                    )
                                  "
                                ></i>
                              </p>
                              <form
                                [id]="'form-subgroup-' + subgroup.id + '-edit'"
                                [formGroup]="formGeojsonSubgroup"
                                (ngSubmit)="
                                  onSubmitForm(
                                    'formGeojsonSubgroup',
                                    'edit',
                                    group._id,
                                    subgroup.id
                                  )
                                "
                                style="display: none"
                              >
                                <div class="form-row">
                                  <div class="col-9">
                                    <div class="form-group p-0">
                                      <input
                                        formControlName="name"
                                        type="text"
                                        class="form-control"
                                        placeholder="{{
                                          subgroup.name | translate
                                        }}"
                                      />
                                    </div>
                                  </div>
                                  <div class="col-3 d-flex form-group">
                                    <div class="action-btn">
                                      <button
                                        class="
                                          btn
                                          btn-sm
                                          btn-circle
                                          btn-outline-primary
                                          btn-tool
                                        "
                                        type="submit"
                                      >
                                        <i [class]="'icon-pencil'"></i>
                                        <span
                                          class="tooltip-text"
                                          style="
                                            margin-top: -3em;
                                            margin-left: -4.5em;
                                          "
                                          >Edit Sub Group
                                        </span>
                                      </button>
                                    </div>
                                    <div class="action-btn">
                                      <button
                                        class="
                                          btn
                                          btn-sm
                                          btn-circle
                                          btn-outline-danger
                                        "
                                        type="button"
                                        (click)="
                                          hideElement(
                                            subgroup.id + '-edit',
                                            'subgroup'
                                          )
                                        "
                                      >
                                        <i class="icon-delete"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </form>
                              <ul class="nested">
                                <li
                                  class="list-group-item"
                                  style="position: inherit"
                                  *ngFor="
                                    let layer of subgroup.map_layer;
                                    trackById
                                  "
                                >
                                  <div
                                    class="toggle-container"
                                    style="text-overflow: ellipsis"
                                  >
                                    <app-toggle-switch
                                      [selected]="
                                        geojsonLayerFilter.includes(layer.id)
                                      "
                                      (change)="toggleGeojsonLayer(layer.id)"
                                    ></app-toggle-switch>
                                    <i
                                      class="icon-pencil ml-2 m-0"
                                      (click)="onToggleGeojsonTool(layer)"
                                    ></i>
                                    <p class="ellipsis">
                                      {{ layer.layer_name }}
                                    </p>
                                  </div>
                                </li>
                                <!-- ------------------------------ Add Layer ------------------------------ -->
                                <li>
                                  <p
                                    *ngIf="isEditGeojson"
                                    [id]="'btn-layer-' + subgroup.id"
                                    style="cursor: pointer"
                                    (click)="showElement(subgroup.id, 'layer')"
                                  >
                                    Add Layer
                                  </p>
                                  <form
                                    [id]="'form-layer-' + subgroup.id"
                                    [formGroup]="formGeojsonLayer"
                                    (ngSubmit)="
                                      onSubmitForm(
                                        'formGeojsonLayer',
                                        'add',
                                        '',
                                        subgroup.id
                                      )
                                    "
                                    style="display: none"
                                  >
                                    <div class="form-row">
                                      <div class="col-9">
                                        <div class="form-group p-0">
                                          <select
                                            formControlName="map_layer"
                                            class="form-control"
                                          >
                                            <option
                                              *ngFor="
                                                let type of geojsonLayers;
                                                trackById
                                              "
                                              [value]="[type.id]"
                                            >
                                              {{ type.layer_name | titlecase }}
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                      <div class="col-3 d-flex form-group">
                                        <div class="action-btn">
                                          <button
                                            class="
                                              btn
                                              btn-sm
                                              btn-circle
                                              btn-outline-primary
                                              btn-tool
                                            "
                                            type="submit"
                                          >
                                            <i [class]="'icon-create'"></i>
                                            <span
                                              class="tooltip-text"
                                              style="
                                                margin-top: -3em;
                                                margin-left: -4.5em;
                                              "
                                              >Add Layer
                                            </span>
                                          </button>
                                        </div>

                                        <div class="action-btn">
                                          <button
                                            class="
                                              btn
                                              btn-sm
                                              btn-circle
                                              btn-outline-danger
                                            "
                                            type="button"
                                            (click)="
                                              hideElement(subgroup.id, 'layer')
                                            "
                                          >
                                            <i class="icon-delete"></i>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </form>
                                </li>
                              </ul>
                            </li>
                            <!-- ---------------------------- Add Subgroup ----------------------------- -->
                            <li>
                              <p
                                [id]="'btn-subgroup-' + group._id + '-add'"
                                *ngIf="isEditGeojson"
                                style="cursor: pointer"
                                (click)="
                                  showElement(group._id + '-add', 'subgroup')
                                "
                              >
                                Add Sub Group
                              </p>
                            </li>
                            <form
                              [id]="'form-subgroup-' + group._id + '-add'"
                              [formGroup]="formGeojsonSubgroup"
                              (ngSubmit)="
                                onSubmitForm(
                                  'formGeojsonSubgroup',
                                  'add',
                                  group._id
                                )
                              "
                              style="display: none"
                            >
                              <div class="form-row">
                                <div class="col-9">
                                  <div class="form-group p-0">
                                    <input
                                      formControlName="name"
                                      type="text"
                                      class="form-control"
                                      placeholder="{{
                                        'Sub Group Name' | translate
                                      }}"
                                    />
                                  </div>
                                </div>
                                <div class="col-3 d-flex form-group">
                                  <div class="action-btn">
                                    <button
                                      class="
                                        btn
                                        btn-sm
                                        btn-circle
                                        btn-outline-primary
                                        btn-tool
                                      "
                                      type="submit"
                                    >
                                      <i [class]="'icon-create'"></i>
                                      <span
                                        class="tooltip-text"
                                        style="
                                          margin-top: -3em;
                                          margin-left: -4.5em;
                                        "
                                        >Add Sub Group
                                      </span>
                                    </button>
                                  </div>
                                  <div class="action-btn">
                                    <button
                                      class="
                                        btn btn-sm btn-circle btn-outline-danger
                                      "
                                      type="button"
                                      (click)="
                                        hideElement(
                                          group._id + '-add',
                                          'subgroup'
                                        )
                                      "
                                    >
                                      <i class="icon-delete"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <!-- ------------------------ Create Geojson Group ------------------------- -->
                  <form
                    *ngIf="isShowFormGroup"
                    [formGroup]="formGeojsonGroup"
                    (ngSubmit)="onSubmitForm('formGeojsonGroup', 'add')"
                  >
                    <div class="form-row">
                      <div class="col-9">
                        <div class="form-group p-0">
                          <input
                            formControlName="name"
                            type="text"
                            class="form-control"
                            placeholder="{{ 'Group Name' | translate }}"
                          />
                        </div>
                      </div>
                      <div class="col-3 d-flex form-group">
                        <div class="action-btn">
                          <button
                            class="
                              btn btn-sm btn-circle btn-outline-primary btn-tool
                            "
                            type="submit"
                          >
                            <i [class]="'icon-create'"></i>
                            <span
                              class="tooltip-text"
                              style="margin-top: -3em; margin-left: -4.5em"
                              >Create Group
                            </span>
                          </button>
                        </div>
                        <div class="action-btn">
                          <button
                            class="btn btn-sm btn-circle btn-outline-danger"
                            type="button"
                            (click)="isShowFormGroup = !isShowFormGroup"
                          >
                            <i class="icon-delete"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                  <!-- -------------------- layer that do not have group --------------------- -->
                  <li
                    class="list-group-item"
                    style="position: inherit"
                    *ngFor="let item of geojsonLayers; trackById"
                  >
                    <div class="toggle-container">
                      <app-toggle-switch
                        [selected]="geojsonLayerFilter.includes(item.id)"
                        (change)="toggleGeojsonLayer(item.id)"
                      ></app-toggle-switch>
                      <i
                        class="icon-pencil ml-2 m-0"
                        (click)="onToggleGeojsonTool(item)"
                      ></i>
                      <p class="ellipsis">{{ item.layer_name }}</p>
                    </div>
                  </li>
                  <!-- ------------------------- color picker tools -------------------------- -->
                  <div
                    class="card card-body"
                    style="position: absolute; left: 20em; margin-top: -1em"
                    *ngIf="
                      selectedGeojson &&
                      toggleGeojsonTool.includes(selectedGeojson.id)
                    "
                  >
                    <p class="card-title font-weight-bold text-left">
                      Layer Edit Tools: {{ selectedGeojson.layer_name }}
                    </p>
                    <form
                      #geojsonToolForm="ngForm"
                      (ngSubmit)="
                        saveGeojsonLayerStyle(
                          selectedGeojson.id,
                          geojsonToolForm.value
                        )
                      "
                    >
                      <input
                        type="hidden"
                        name="layer_id"
                        [ngModel]="selectedGeojson.id"
                      />
                      <div
                        class="form-group row no-gutters mb-0"
                        *ngIf="geojsonLayerTool_fill_color !== undefined"
                      >
                        <label class="col-sm-6 col-form-label"
                          >Fill Color</label
                        >
                        <div class="col-sm-6">
                          <input
                            type="color"
                            class="
                              form-control form-control-color form-control-sm
                            "
                            id="exampleColorInput1"
                            [ngModel]="
                              selectedGeojson.fill_color ||
                              geojsonLayerTool_fill_color
                            "
                            title="Choose your color"
                            name="fill_color"
                          />
                        </div>
                      </div>
                      <div
                        class="form-group row no-gutters mb-0"
                        *ngIf="geojsonLayerTool_line_color !== undefined"
                      >
                        <label class="col-sm-6 col-form-label"
                          >Stroke/Line Color</label
                        >
                        <div class="col-sm-6">
                          <input
                            type="color"
                            class="
                              form-control form-control-color form-control-sm
                            "
                            id="exampleColorInput2"
                            [ngModel]="
                              selectedGeojson.line_color ||
                              geojsonLayerTool_line_color
                            "
                            title="Choose your color"
                            name="line_color"
                          />
                        </div>
                      </div>
                      <div
                        class="form-group row no-gutters mb-0"
                        *ngIf="geojsonLayerTool_line_width !== undefined"
                      >
                        <label class="col-sm-6 col-form-label"
                          >Stroke width</label
                        >
                        <div class="col-sm-6">
                          <input
                            type="number"
                            class="form-control form-control-sm"
                            name="line_width"
                            [ngModel]="
                              selectedGeojson.line_width ||
                              geojsonLayerTool_line_width
                            "
                          />
                        </div>
                      </div>
                      <!-- /** 
                        * line-dasharray only supported >= 2.3.0 
                        * current version is: 1.9.1
                        * */ -->
                      <!-- <div class="form-group row no-gutters mb-0">
                          <label class="col-sm-6 col-form-label"
                            >Stroke style</label
                          >
                          <div class="col-sm-6">
                            <select
                              class="form-control form-control-sm"
                              name="line_dasharray"
                              [ngModel]="
                                item.line_dasharray ||
                                geojsonLayerTool_line_dasharray
                              "
                            >
                              <option value="[1]" selected>Solid Line</option>
                            </select>
                          </div>
                        </div> -->
                      <div class="form-buttons">
                        <button
                          type="button"
                          class="btn btn-sm btn-secondary"
                          (click)="onToggleGeojsonTool(0)"
                        >
                          {{ "Discard" | translate }}
                        </button>
                        <button type="submit" class="btn btn-sm btn-primary">
                          {{ "Save" | translate }}
                        </button>
                      </div>
                    </form>
                  </div>
                </ng-container>
              </ul>
            </div>
          </div>
        </li>
      </ng-container>
      <!-- <li class="list-group-item">
        <div class="toggle-container">
          <app-toggle-switch></app-toggle-switch>
          <i class="icon-canvas"></i>
          <p>{{ 'Asset Classes' | translate }}</p>
        </div>
      </li>
      <li class="list-group-item">
        <div class="toggle-container">
          <app-toggle-switch></app-toggle-switch>
          <i class="icon-canvas"></i>
          <p>{{ 'Legend' | translate }}</p>
        </div>
      </li> -->
      <ng-container *ngIf="currLocation?.map_layer_3d && !splitScreenOn">
        <li class="list-group-item">
          <div class="toggle-container">
            <app-toggle-switch
              [selected]="isThreeD"
              (change)="toggleSwitch('map_layer', '3d')"
            ></app-toggle-switch>
            <i class="icon-d-mesh"></i>
            <p>{{ "Point Cloud" | translate }}</p>
            <div class="action-btn ml-1" *ngIf="!isSplitscreenOn">
              <a
                class="btn btn-sm btn-circle btn-outline-primary btn-tool"
                (click)="onPinMapLayer('3d_' + currLocation?.map_layer_3d.id)"
                [class.active]="
                  currLocation.pinned_map_layer_type?.includes('3d') ||
                  currLocation.pinned_map_layer_type?.includes(
                    '3d_' + currLocation?.map_layer_3d.id
                  )
                "
                data-cy="pin-layer-3d-button"
              >
                <i [class]="'icon-clusters'"></i>
                <span
                  class="tooltip-text"
                  style="margin-top: -3em; margin-left: -3.5em"
                  >{{
                    currLocation.pinned_map_layer_type?.includes("3d") ||
                    currLocation.pinned_map_layer_type?.includes(
                      "3d_" + currLocation?.map_layer_3d.id
                    )
                      ? "Unpin layer"
                      : ("Pin layer" | translate)
                  }}</span
                >
              </a>
            </div>
            -->
          </div>
        </li>
        <li *ngIf="isThreeD && !splitScreenOn" class="list-group-item">
          <div class="toggle-container">
            <app-toggle-switch
              [selected]="false"
              (change)="onToggleOrbitChanged($event)"
            ></app-toggle-switch>
            <i class="icon-d-mesh"></i>
            <p>{{ "Orbit" | translate }}</p>
          </div>
        </li>
      </ng-container>
      <ng-container *ngIf="currLocation?.map_layer_facade && !splitScreenOn">
        <li class="list-group-item">
          <div class="toggle-container">
            <app-toggle-switch
              [selected]="isFacade"
              (change)="toggleSwitch('map_layer', 'facade')"
            ></app-toggle-switch>
            <i class="icon-d-mesh"></i>
            <p>{{ "Facade" | translate }}</p>
            <div class="action-btn ml-1" *ngIf="!isSplitscreenOn">
              <a
                class="btn btn-sm btn-circle btn-outline-primary btn-tool"
                (click)="
                  onPinMapLayer('facade_' + currLocation?.map_layer_facade.id)
                "
                [class.active]="
                  currLocation.pinned_map_layer_type?.includes('facade') ||
                  currLocation.pinned_map_layer_type?.includes(
                    'facade_' + currLocation?.map_layer_facade.id
                  )
                "
              >
                <i [class]="'icon-clusters'"></i>
                <span
                  class="tooltip-text"
                  style="margin-top: -3em; margin-left: -3.5em"
                  >{{
                    currLocation.pinned_map_layer_type?.includes("facade") ||
                    currLocation.pinned_map_layer_type?.includes(
                      "facade_" + currLocation?.map_layer_facade.id
                    )
                      ? "Unpin layer"
                      : ("Pin layer" | translate)
                  }}</span
                >
              </a>
            </div>
          </div>
        </li>
      </ng-container>
      <!-- <li class="list-group-item">
        <div class="toggle-container">
          <app-toggle-switch></app-toggle-switch>
          <i class="icon-canvas"></i>
          <p>{{ 'Vegetation Index' | translate }}</p>
        </div>
        <div class="card inner-shadow w-100">
          <div class="card-body">test</div>
        </div>
      </li> -->
      <li class="list-group-item">
        <div class="toggle-container">
          <app-toggle-switch
            [selected]="isSatellite"
            (change)="toggleSwitch('satellite')"
          ></app-toggle-switch>
          <i class="icon-satellite"></i>
          <p>{{ "Satellite" | translate }}</p>
        </div>
      </li>
      <!-- <li class="list-group-item">
        <p (click)="loadPointCloud()" class="link">Load Point Cloud</p>
        <p (click)="activateTool('measure-height')" class="link">Activate Measure Height</p>
        <p (click)="activateTool('measure-distance')" class="link">Activate Measure Distance</p>
        <p (click)="unloadAllPointCloud()" class="link">Unload Point Cloud</p>
      </li> -->
      <!-- <li class="list-group-item">
        <div class="toggle-container">
          <app-toggle-switch></app-toggle-switch>
          <i class="icon-arrow-top-right"></i>
          <p>{{ 'Image Metadata' | translate }}</p>
        </div>
      </li>
      <li class="list-group-item">
        <div class="toggle-container">
          <app-toggle-switch></app-toggle-switch>
          <i class="icon-clusters"></i>
          <p>{{ 'Clusters' | translate }}</p>
        </div>
      </li> -->
      <li class="list-group-item annotation-container" *ngIf="currLocation?.id">
        <div class="toggle-container">
          <app-toggle-switch
            [selected]="isAnnotation"
            (change)="toggleSwitch('annotations')"
          ></app-toggle-switch>
          <i class="icon-annotation-box-2"></i>
          <p>{{ "Annotations" | translate }}</p>
        </div>
        <!-- <div class="nested-toggle" *ngIf="false && isAnnotation">
          <div class="card card-body">
            <ul class="list-group" style="border-bottom: 0px">
              <ng-container *ngIf="annotations?.location_component?.length > 1">
                <p class="text-left mb-2 font-weight-bold">{{ 'Components' | translate }}</p>
                <li class="list-group-item" *ngFor="let item of annotations.location_component">
                  <div class="toggle-container">
                    <app-toggle-switch [selected]="componentFilter.includes(item._id)" (change)="toggleAnnotationBy('location_component', item._id)"></app-toggle-switch>
                    <p>{{ genericTypeKeyId[item?._id]?.name | translate }}</p>
                  </div>
                </li>
              </ng-container>

              <ng-container *ngIf="annotations?.annotation_type?.length > 0">
                <p class="text-left mb-2 font-weight-bold">{{ 'Defect Type' | translate }}</p>
                <li class="list-group-item" *ngFor="let item of annotations.annotation_type">
                  <div class="toggle-container">
                    <app-toggle-switch [selected]="defectFilter.includes(item._id)" (change)="toggleAnnotationBy('annotation_type', item._id)"></app-toggle-switch>
                    <p>{{ genericTypeKeyId[item?._id]?.name | translate }}</p>
                  </div>
                </li>
              </ng-container>

              <ng-container *ngIf="annotations?.severity_type?.length > 0">
                <p class="text-left mb-2 font-weight-bold">{{ 'Severity' | translate }}</p>
                <li class="list-group-item" *ngFor="let item of annotations.severity_type">
                  <div class="toggle-container">
                    <app-toggle-switch [selected]="severityFilter.includes(item._id)" (change)="toggleAnnotationBy('severity_type', item._id)"></app-toggle-switch>
                    <p>{{ genericTypeKeyId[item?._id]?.name | translate }}</p>
                  </div>
                </li>
              </ng-container>
            </ul>
            <div *ngIf="currLocation?.id" class="d-flex justify-content-end mt-3" style="width: 100%">
              <div (click)="genFilteredReport()" class="btn btn-primary btn-sm">
                {{'Get Filtered Report' | translate}}
              </div>
            </div>
          </div>
        </div> -->
      </li>
      <!-- <li class="list-group-item annotation-container" *ngIf="currLocation?.id && isLarsenToubro">
        <div class="toggle-container">
          <app-toggle-switch [selected]="isAsset" (change)="toggleSwitch('assets')"></app-toggle-switch>
          <i class="icon-annotation-box-2"></i>
          <p>{{ 'Assets' | translate }}</p>
        </div>
      </li>
      <li class="list-group-item annotation-container" *ngIf="currLocation?.id && isLarsenToubro">
        <div class="toggle-container">
          <app-toggle-switch [selected]="isBoundary" (change)="toggleSwitch('boundaries')"></app-toggle-switch>
          <i class="icon-annotation-box-2"></i>
          <p>{{ 'Boundaries' | translate }}</p>
        </div>
      </li>
      <li class="list-group-item annotation-container" *ngIf="currLocation?.id && isLarsenToubro">
        <div class="toggle-container">
          <app-toggle-switch [selected]="isBuilding" (change)="toggleSwitch('buildings')"></app-toggle-switch>
          <i class="icon-annotation-box-2"></i>
          <p>{{ 'Buildings' | translate }}</p>
        </div>
      </li>
      <li class="list-group-item annotation-container" *ngIf="currLocation?.id && isLarsenToubro">
        <div class="toggle-container">
          <app-toggle-switch [selected]="isOpenArea" (change)="toggleSwitch('openAreas')"></app-toggle-switch>
          <i class="icon-annotation-box-2"></i>
          <p>{{ 'Open Areas' | translate }}</p>
        </div>
      </li> -->
      <!-- <li class="list-group-item">
        <div class="toggle-container">
          <app-toggle-switch></app-toggle-switch>
          <i class="icon-canvas"></i>
          <p>{{ 'Grid' | translate }}</p>
        </div>
      </li>
      <li class="list-group-item">
        <div class="toggle-container">
          <app-toggle-switch></app-toggle-switch>
          <i class="icon-flight-path"></i>
          <p>{{ 'Flight Path' | translate }}</p>
        </div>
      </li>
      <li class="list-group-item">
        <div class="toggle-container">
          <app-toggle-switch></app-toggle-switch>
          <i class="icon-contours"></i>
          <p>{{ 'Elevation' | translate }}</p>
        </div>
      </li> -->
      <ng-container
        *ngIf="currLocation?.id && hasGalleryImages && !splitScreenOn"
      >
        <li class="list-group-item">
          <div class="toggle-container">
            <app-toggle-switch
              [selected]="isGalleryImages"
              (change)="toggleGalleryImages()"
            ></app-toggle-switch>
            <i class="icon-ortho"></i>
            <p>{{ "Gallery Images Marker" | translate }}</p>
          </div>
        </li>
      </ng-container>
    </ul>
    <ng-container *ngIf="currLocation?.id">
      <div class="title guide-title text-left">
        <h3 class="card-title">{{ "Guide" | translate }}</h3>
      </div>
      <ul class="list-group">
        <li class="list-group-item">
          <div class="toggle-container">
            <app-toggle-switch
              [selected]="mapService.isGrid$.getValue()"
              (change)="toggleSwitch('grid', null, $event)"
            ></app-toggle-switch>
            <i class="icon-canvas"></i>
            <p>{{ "Grid" | translate }}</p>
          </div>
        </li>
        <li class="list-group-item">
          <div class="slider-container">
            <div class="slider-rotate slider-grid"></div>
            <p>{{ "Rotate" | translate }}</p>
          </div>
        </li>
        <li class="list-group-item">
          <div class="toggle-container">
            <input
              [formControl]="rateControl"
              onkeydown="return !(event.keyCode === 69 || event.keyCode === 190)"
              class="rotateInput hide-input-arrow"
              type="number"
              min="0"
              max="90"
              name=""
              [value]="mapService.gridRotateAngle"
              (change)="onRotateInputChange($event)"
            />
            <p>{{ "Rotate" | translate }}</p>
          </div>
        </li>
        <li class="list-group-item">
          <div class="toggle-container">
            <button class="reset-grid-button" (click)="onResetGridClicked()">
              {{ "Align Grid" | translate }}
            </button>
          </div>
        </li>
      </ul>
    </ng-container>
  </div>
</div>
